import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { DBCheckBoxComment, DBCheckBoxCommentModu } from '_components';
import styles from './Common.module.css';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';





const components = {

}

class PatientCareCenterNoteObjectiveNeuroSensoryProcessingModulation extends React.Component {

    renderChild(name, mopno) {
        const Child = components[name];
        return Child === undefined ? <span key={name} mopno={mopno} /> : <Child key={name} mopno={mopno} />;
    }

    handleDiagChangeHandel(event) {
        if (event.target.value === '-1') {
            this.props.clearField(this.props.noteId, 'PTOBJECTIVEPEDS', 'OPNO', this.props.opno, 'OPSETOLHANDLING');
        }
        else if (event.target.value !== this.props.handelValue) {
            this.props.updateIntField(this.props.noteId, 'PTOBJECTIVEPEDS', 'OPNO', this.props.opno, 'OPSETOLHANDLING', event.target.value);
        }
    }
    handleDiagChangeMovement(event) {
        if (event.target.value === '-1') {
            this.props.clearField(this.props.noteId, 'PTOBJECTIVEPEDS', 'OPNO', this.props.opno, 'OPSETOLMOVEMENT');
        }
        else if (event.target.value !== this.props.movementValue) {
            this.props.updateIntField(this.props.noteId, 'PTOBJECTIVEPEDS', 'OPNO', this.props.opno, 'OPSETOLMOVEMENT', event.target.value);
        }
    }

    handleDiagChangeEye(event) {
        if (event.target.value === '-1') {
            this.props.clearField(this.props.noteId, 'PTOBJECTIVEPEDS', 'OPNO', this.props.opno, 'OPSEEYECONTACT');
        }
        else if (event.target.value !== this.props.handelValue) {
            this.props.updateIntField(this.props.noteId, 'PTOBJECTIVEPEDS', 'OPNO', this.props.opno, 'OPSEEYECONTACT', event.target.value);
        }
    }

    render() {

        return (
            <>
                <PatientCareCenterNoteSection id='neuro_sens' name='Sensory processing and modulation' level={2} noChildPadding={true}>
                    <div className={styles.sensory_row}>
                        <label className={styles.sensory_label_1}>Tolerance to Handling</label>
                        <select className={styles.diag_drop_down} value={this.props.handelValue ? this.props.handelValue : '-1'} onChange={(event) => this.handleDiagChangeHandel(event)}>
                            <option key={-1} value='-1'></option>
                            <option key={1} value='1'>Good</option>
                            <option key={2} value='2'>Fair</option>
                            <option key={3} value='3'>Poor</option>
                        </select>
                    </div>
                    <br />
                    <div className={styles.sensory_row}>
                        <label className={styles.sensory_label_2}>Tolerance to Movement</label>
                        <select className={styles.diag_drop_down} value={this.props.movementValue ? this.props.movementValue : '-1'} onChange={(event) => this.handleDiagChangeMovement(event)}>
                            <option key={-1} value='-1'></option>
                            <option key={1} value='1'>Good</option>
                            <option key={2} value='2'>Fair</option>
                            <option key={3} value='3'>Poor</option>
                        </select>
                    </div>  <br />
                    <div className={styles.sensory_row}>
                        <label className={styles.sensory_label_3}>Eye Contact</label>
                        <select className={styles.diag_drop_down} value={this.props.eyeValue ? this.props.eyeValue : '-1'} onChange={(event) => this.handleDiagChangeEye(event)}>
                            <option key={-1} value='-1'></option>
                            <option key={1} value='1'>Good</option>
                            <option key={2} value='2'>Fair</option>
                            <option key={3} value='3'>Poor</option>
                        </select>
                    </div>

                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEPOSINSEC'
                                className={styles.checkbox}
                                label='Postural insecurities'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEVISDEF'
                                className={styles.checkbox}
                                label='Visual or hearing deficits'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSECOMDEF'
                                className={styles.checkbox}
                                label='Communication deficits'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEGLASSES'
                                className={styles.checkbox}
                                label='Glasses or hearing aids'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEVISCONV'
                                className={styles.checkbox}
                                label='Visual convergence or peripheral orientation'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEDEPTH'
                                className={styles.checkbox}
                                label='Depth or distance perception'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEBODDEF'
                                className={styles.checkbox}
                                label='Body awareness deficits'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEBILAT'
                                className={styles.checkbox}
                                label='Bilateral integration'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSESAFETY'
                                className={styles.checkbox}
                                label='Safety awareness'
                            />
                        </div>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.label_section}>Child Can:</label>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSESELFCALM'
                                className={styles.checkbox}
                                label='Self Calm / quiet'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEEXPLORE'
                                className={styles.checkbox}
                                label='Explore environment'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEENGPLAY'
                                className={styles.checkbox}
                                label='Engage in play'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSESHIFTATTN'
                                className={styles.checkbox}
                                label='Shift attention'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEINITPLAY'
                                className={styles.checkbox}
                                label='Initiate play'
                            />
                        </div>
                    </div>
                    <div className={styles.row}>
                        <label>Processing of:</label>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxCommentModu
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSETACTILE'
                                className={styles.checkbox}
                                label='Tactile input'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxCommentModu
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEAUDITORY'
                                className={styles.checkbox}
                                label='Auditory input'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxCommentModu
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEPROPRIO'
                                className={styles.checkbox}
                                label='Proprioceptive input'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxCommentModu
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEOLEFACTORY'
                                className={styles.checkbox}
                                label='Olefactory'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxCommentModu
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEINTERO'
                                className={styles.checkbox}
                                label='Interoception'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxCommentModu
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEORAL'
                                className={styles.checkbox}
                                label='Oral input'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxCommentModu
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEVESTIB'
                                className={styles.checkbox}
                                label='Vestibular input'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxCommentModu
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPSEVISINPUT'
                                className={styles.checkbox}
                                label='Visual input'
                            />
                        </div>
                    </div>
                </PatientCareCenterNoteSection>
                <PatientCareCenterNoteSection id='neuro_sens' name='Skills' level={2} noChildPadding={true}>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVIVISMOTINT'
                                className={styles.checkbox}
                                label='Motor Integration'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVIVISATT'
                                className={styles.checkbox}
                                label='Attention'
                            />
                        </div>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.label_header}>Perception</label>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVIFIGURE'
                                className={styles.checkbox}
                                label='Figure Ground'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVIFORM'
                                className={styles.checkbox}
                                label='Form constancy'
                            />
                        </div>
                    </div>


                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVIVISMEM'
                                className={styles.checkbox}
                                label='memory'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVIVISSPA'
                                className={styles.checkbox}
                                label='spatial'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVIVISCLO'
                                className={styles.checkbox}
                                label='closure'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVIVISDIS'
                                className={styles.checkbox}
                                label='discrimination'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVICOPY'
                                className={styles.checkbox}
                                label='Copying'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVIOTHER'
                                className={styles.checkbox}
                                label='Other'
                            />
                        </div>
                    </div>
                    <label className={styles.label_header}>Oculomotor Control</label>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVIREFLEX'
                                className={styles.checkbox}
                                label='Reflexes'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVICONVERGE'
                                className={styles.checkbox}
                                label='Convergence'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVIDIVERGE'
                                className={styles.checkbox}
                                label='Divergence'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVISACCADES'
                                className={styles.checkbox}
                                label='Saccades'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVITRACK'
                                className={styles.checkbox}
                                label='Tracking'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVISCAN'
                                className={styles.checkbox}
                                label='Scanning'
                            />
                        </div>
                    </div>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVIPURSUITS'
                                className={styles.checkbox}
                                label='Pursuits'
                            />
                        </div>
                    </div>

                    <label className={styles.label_header}>Visual Motor</label>
                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVSPREWRITE'
                                className={styles.checkbox}
                                label='Prewriting'
                            />
                        </div>
                    </div>

                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVSWRITE'
                                className={styles.checkbox}
                                label='Writing'
                            />
                        </div>
                    </div>


                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVSCUTTING'
                                className={styles.checkbox}
                                label='Cutting'
                            />
                        </div>
                    </div>

                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVSCUTGLUE'
                                className={styles.checkbox}
                                label='Cut and glue'
                            />
                        </div>
                    </div>

                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVSPUZZLE'
                                className={styles.checkbox}
                                label='Puzzles'
                            />
                        </div>
                    </div>

                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVSCOPYBLOCK'
                                className={styles.checkbox}
                                label='Copying 3D block designs'
                            />
                        </div>
                    </div>

                    <div className={styles.form_row}>
                        <div className={styles.gap}>
                            <DBCheckBoxComment
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEPEDS'
                                entityKeyColumn='OPNO'
                                entityKeyValue={this.props.opno}
                                field='OPVSOTHER'
                                className={styles.checkbox}
                                label='Other'
                            />
                        </div>
                    </div>

                </PatientCareCenterNoteSection>
            </>
        );

    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));

    let handelValue = state.entities.notes.PTOBJECTIVEPEDS[opno].OPSETOLHANDLING !== null ? state.entities.notes.PTOBJECTIVEPEDS[opno].OPSETOLHANDLING : undefined;
    let movementValue = state.entities.notes.PTOBJECTIVEPEDS[opno].OPSETOLMOVEMENT !== null ? state.entities.notes.PTOBJECTIVEPEDS[opno].OPSETOLMOVEMENT : undefined;
    let eyeValue = state.entities.notes.PTOBJECTIVEPEDS[opno].OPSEEYECONTACT !== null ? state.entities.notes.PTOBJECTIVEPEDS[opno].OPSEEYECONTACT : undefined;

    return {
        noteId: noteId,
        opno: opno,
        handelValue: handelValue,
        movementValue: movementValue,
        eyeValue: eyeValue,
    };
}

const connectedPatientCareCenterNoteObjectiveNeuroSensoryProcessingModulation = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveNeuroSensoryProcessingModulation);
export { connectedPatientCareCenterNoteObjectiveNeuroSensoryProcessingModulation as PatientCareCenterNoteObjectiveNeuroSensoryProcessingModulation };

